import { useState, useEffect, useCallback } from "react"

const isActive = status => status === "started" || status === "processing"

export function useBulkNotifications() {
  const [topics, setTopics] = useState([])

  const refresh = useCallback(async () => {
    try {
      const response = await fetch("/notifications")
      if (!response.ok) return
      const data = await response.json()
      setTopics(data.notifications ?? [])
    } catch {
      // best-effort, same as existing Notifications component
    }
  }, [])

  useEffect(() => {
    refresh()
    window.addEventListener("notifications:refresh", refresh)
    return () => window.removeEventListener("notifications:refresh", refresh)
  }, [refresh])

  const activeTopic = topics.find(t => isActive(t.status)) ?? null
  const progress = activeTopic?.progress
    ? activeTopic.progress.current / activeTopic.progress.total
    : 0
  const completedCount = topics.filter(t => !isActive(t.status)).length

  return { topics, activeTopic, progress, completedCount, hasTopics: topics.length > 0 }
}
